import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../common_components/mdae-framework";
import {
  actionTypes as asyncTypes,
  isAsyncComplete,
  isAsyncOperation
} from "async-ops";
import { format } from "date-fns";
import { cloneDeep, cloneDeepWith } from "lodash";
import { GET_AUDIT_SUMMARY_DATA } from "../services/get-audit-summary-data";
import { GET_ESMD_SUBMISSION_BY_AUDIT_ID } from "../services/get-esmd-submission-by-audit-id";
import { GET_EA_NARRATIVE_SUMMARY } from "../services/get-ea-narrative-summary";
import { GET_EXTERNAL_AUDIT_HISTORY } from "../services/get-external-audit-history";
export const TOGGLE_UPLOAD_NARRATIVE_SUMMARY_POPUP =
  "TOGGLE_UPLOAD_NARRATIVE_SUMMARY_POPUP";
export const SET_NARRATIVE_SUMMARY_NOTE_VALUE =
  "SET_NARRATIVE_SUMMARY_NOTE_VALUE";
export const SET_AUDIT_MODE = "SET_AUDIT_MODE";
export const SET_EXTERNAL_AUDIT_SELECTED_INDEX =
  "SET_EXTERNAL_AUDIT_SELECTED_INDEX";
export const TOGGLE_SAVE_AND_CONTINUE_CLICK = "TOGGLE_SAVE_AND_CONTINUE_CLICK";
export const SET_EA_CASES_LIST = "SET_EA_CASES_LIST";
export const SET_AUDIT_ROUND_DATA = "SET_AUDIT_ROUND_DATA";
export const SET_AUDIT_SUMMERY_DATA = "SET_AUDIT_SUMMERY_DATA";
export const SET_EA_PROCESS_TEMPLATE_ROUND_LIST =
  "SET_EA_PROCESS_TEMPLATE_ROUND_LIST";
export const TOGGLE_NO_ADVANCE_ROUND_WARNING_POPUP =
  "TOGGLE_NO_ADVANCE_ROUND_WARNING_POPUP";
export const TOGGLE_DETERMINATION_DATE_REQUIRED_WARNING_POPUP =
  "TOGGLE_DETERMINATION_DATE_REQUIRED_WARNING_POPUP";
export const TOGGLE_PROCESS_REQUIRED_WARNING_POPUP =
  "TOGGLE_PROCESS_REQUIRED_WARNING_POPUP";
export const SET_NEW_DETERMINATION_DATE = "SET_NEW_DETERMINATION_DATE";
export const SET_NEW_SUBMISSION_DATE = "SET_NEW_SUBMISSION_DATE";
export const TOGGLE_END_DATE_ADVANCE_ROUND_WARNING_POPUP =
  "TOGGLE_END_DATE_ADVANCE_ROUND_WARNING_POPUP";
export const SET_OLD_EA_ROUND_OBJECT = "SET_OLD_EA_ROUND_OBJECT";
export const TOGGLE_UNDO_ICON_VISIBLE = "TOGGLE_UNDO_ICON_VISIBLE";
export const SET_USER_TASK_LIST_GRID_INSTANCE =
  "SET_USER_TASK_LIST_GRID_INSTANCE";
export const SET_CURRENT_ROUND_DATA = "SET_CURRENT_ROUND_DATA";
export const SET_ADVANCED_TO_NEXT_ROUND = "SET_ADVANCED_TO_NEXT_ROUND";
export const ADD_NEW_ROUND_TO_EXISTING_ROUNDS =
  "ADD_NEW_ROUND_TO_EXISTING_ROUNDS";
export const REMOVE_NEW_ADDED_ROUND = "REMOVE_NEW_ADDED_ROUND";
export const SET_ADVANCE_ROUND_TASK_TRIGGER_CREATION =
  "SET_ADVANCE_ROUND_TASK_TRIGGER_CREATION";
export const UPDATE_ROUND_DATA_BY_SEQUENCE_NO =
  "UPDATE_ROUND_DATA_BY_SEQUENCE_NO";
export const SET_REFRESH_AUDIT_SUMMARY_DATA = "SET_REFRESH_AUDIT_SUMMARY_DATA";
export const SET_USER_TASK_GRID_FILTER = "SET_USER_TASK_GRID_FILTER";
export const SET_ROUNDS_REQUESTERS_LIST = "SET_ROUNDS_REQUESTERS_LIST";
export const SET_NO_ADDITIONAL_ROUNDS_MESSAGE =
  "SET_NO_ADDITIONAL_ROUNDS_MESSAGE";
export const SET_EXTERNAL_AUDIT_TAB_VISIBLE = "SET_EXTERNAL_AUDIT_TAB_VISIBLE";
export const SET_DOCUMENT_COUNT_PROPERTY = "SET_DOCUMENT_COUNT_PROPERTY";
export const SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER = "SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER";
export const SET_VALID_INITIAL_CONTENT_TYPE_LIST = "SET_VALID_INITIAL_CONTENT_TYPE_LIST";
export const SET_VALID_CURRENT_CONTENT_TYPE_LIST = "SET_VALID_CURRENT_CONTENT_TYPE_LIST";
export const SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR = "SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR";
export const SET_IS_PROCESS_TEMPLATE_VALID = "SET_IS_PROCESS_TEMPLATE_VALID";
export const SET_ESMD_SUBMISSION_LIST = "SET_ESMD_SUBMISSION_LIST";
export const TOGGLE_ADD_CASE_TO_ROUND_POPUP='TOGGLE_ADD_CASE_TO_ROUND_POPUP';
export const SET_ADD_CASE_TO_ROUND_DATA = 'SET_ADD_CASE_TO_ROUND_DATA';
export const SET_AUDIT_HISTORY_FILTERS="SET_AUDIT_HISTORY_FILTERS";
export const SET_EMDR_CASE_SEARCH_DOCUMENT_ID = "SET_EMDR_CASE_SEARCH_DOCUMENT_ID";
export const SET_AUDIT_HISTORY_TITLE="SET_AUDIT_HISTORY_TITLE";
const initialError = {
  code: "",
  message: "",
  value: [],
};

const eaRoundDefaultObject = {
  eaAuditId: 0,
  sequenceNo: 0,
  submissionDate: null,
  submissionDeadlineDate: null,
  determinationDate: null,
  eaProcessTemplateRoundId: null,
};

const initialState = {
  loading: false,
  error: initialError,
  eaAuditRounds: [],
  roundsRequestersList: [],
  narrativeSummaryValue: null,
  origNarrativeSummaryValue: null,
  externalAuditSelectedIndex: 0,
  auditSummeryData: {},
  allEaRoundNotes: {},
  newDeterminationDate: null,
  newSubmissionDate: null,
  oldEaAuditRound: eaRoundDefaultObject,
  advancedToNextRound: false,
  refreshAuditSummaryData: false,
  isProcessTemplateValid: true,
  externalAuditHistoryList:[],
  emdrDocumentIdPendingAttachment: 0,
  historyFilters:{},
};
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_ESMD_SUBMISSION_LIST:
    case SET_EXTERNAL_AUDIT_TAB_VISIBLE:
    case TOGGLE_ADD_CASE_TO_ROUND_POPUP:
    case SET_ADD_CASE_TO_ROUND_DATA:
      return { ...state, ...action.data };
    case SET_REFRESH_AUDIT_SUMMARY_DATA:
      return { ...state, refreshAuditSummaryData: action.data };
    case SET_CURRENT_ROUND_DATA:
      newState = cloneDeepWith(state);
      const index = action.data.eaAuditRound.index;
      const currentRound = { ...newState.eaAuditRounds[index] };
      for (let prop in action.data.eaAuditRound) {
        currentRound[prop] = action.data.eaAuditRound[prop];
      }
      const newAuditRounds = [...newState.eaAuditRounds];
      newAuditRounds[index] = currentRound;
      return { ...newState, eaAuditRounds: newAuditRounds };
    case UPDATE_ROUND_DATA_BY_SEQUENCE_NO:
      newState = cloneDeepWith(state);
      const sequenceNo = action.data.eaAuditRound.sequenceNo;
      const currentRoundIndex = newState.eaAuditRounds.findIndex(
        (x) => x.sequenceNo === sequenceNo
      );
      const currentRoundData = { ...newState.eaAuditRounds[currentRoundIndex] };
      for (let prop in action.data.eaAuditRound) {
        currentRoundData[prop] = action.data.eaAuditRound[prop];
      }
      const newAuditRoundsData = [...newState.eaAuditRounds];
      newAuditRoundsData[currentRoundIndex] = currentRoundData;
      return { ...newState, eaAuditRounds: newAuditRoundsData };
    case ADD_NEW_ROUND_TO_EXISTING_ROUNDS:
      newState = cloneDeepWith(state);
      let newRound = action.data;
      let newEARounds = [...newState.eaAuditRounds];
      newEARounds.splice(0, 0, newRound);
      newState = { ...newState, eaAuditRounds: newEARounds };
      return newState;
    case REMOVE_NEW_ADDED_ROUND:
      newState = cloneDeepWith(state);
      let newEaRounds = [...newState.eaAuditRounds];
      newEaRounds = newEaRounds.slice(1);
      newState = { ...newState, eaAuditRounds: newEaRounds };
      return newState;
    case SET_AUDIT_ROUND_DATA:
      return { ...state, ...action.data };
    case SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER:
      return { ...state, isCurrentRequesterReviewContractorValid: action.data }
    case SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR:
      return { ...state, isCurrentContentTypeInvalidForReviewContractor: action.data }
    case SET_IS_PROCESS_TEMPLATE_VALID:
      return { ...state, isProcessTemplateValid: action.data }
    case SET_ADVANCE_ROUND_TASK_TRIGGER_CREATION:
    case SET_ROUNDS_REQUESTERS_LIST:
    case SET_USER_TASK_GRID_FILTER:
    case SET_ADVANCED_TO_NEXT_ROUND:
    case TOGGLE_UPLOAD_NARRATIVE_SUMMARY_POPUP:
    case TOGGLE_SAVE_AND_CONTINUE_CLICK:
    case SET_AUDIT_MODE:
    case SET_AUDIT_SUMMERY_DATA:
    case SET_VALID_CURRENT_CONTENT_TYPE_LIST:
    case SET_EXTERNAL_AUDIT_SELECTED_INDEX:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_NARRATIVE_SUMMARY_NOTE_VALUE:
      return { ...state, ...action.data };
    case SET_NO_ADDITIONAL_ROUNDS_MESSAGE:
    case SET_USER_TASK_LIST_GRID_INSTANCE:
    case SET_EA_CASES_LIST:
    case TOGGLE_UPLOAD_NARRATIVE_SUMMARY_POPUP:
    case TOGGLE_UNDO_ICON_VISIBLE:
    case SET_OLD_EA_ROUND_OBJECT:
    case SET_NEW_DETERMINATION_DATE:
    case SET_NEW_SUBMISSION_DATE:
    case TOGGLE_END_DATE_ADVANCE_ROUND_WARNING_POPUP:
    case TOGGLE_END_DATE_ADVANCE_ROUND_WARNING_POPUP:
    case TOGGLE_DETERMINATION_DATE_REQUIRED_WARNING_POPUP:
    case TOGGLE_PROCESS_REQUIRED_WARNING_POPUP:
    case TOGGLE_NO_ADVANCE_ROUND_WARNING_POPUP:
    case SET_EA_PROCESS_TEMPLATE_ROUND_LIST:
    case SET_DOCUMENT_COUNT_PROPERTY:
      newState = {...state};
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;

    case SET_AUDIT_HISTORY_FILTERS:
      return {
        ...state,
        historyFilters: {
          ...state.historyFilters,
          ...action.data,
        },
      };
    case SET_AUDIT_HISTORY_TITLE:
    return {
      ...state,...action.data
    };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncComplete(GET_AUDIT_SUMMARY_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          auditSummeryData: response.eaSummaryData,
          refreshAuditSummaryData: false,
        };
      }
      if (isAsyncComplete(GET_ESMD_SUBMISSION_BY_AUDIT_ID)(action)) {
        const response = action.response;
        return {
          ...state,
          esmdSubmissionListForAudit: response
        };
      }
      if (isAsyncComplete(GET_EA_NARRATIVE_SUMMARY)(action)) {
        const response = action.response;
        return {
          ...state,
          narrativeSummaryValue: response?.narrativeSummary,
          origNarrativeSummaryValue: response?.narrativeSummary
        };
      }
      if (isAsyncOperation(GET_EXTERNAL_AUDIT_HISTORY)(action)) {
        return { ...state, externalAuditHistoryList: [],loading:true };
      }
      if (isAsyncComplete(GET_EXTERNAL_AUDIT_HISTORY)(action)) {
        const response = action.response;
        return { ...state, externalAuditHistoryList: response,loading:false };
      }

      return state;
    case SET_EMDR_CASE_SEARCH_DOCUMENT_ID:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export const formatAuditObjectToSave = (
  auditPropertiesData,
  eaRound
) => {
  let auditPropertiesDataObject = cloneDeep(auditPropertiesData);
  auditPropertiesDataObject.startDate =
    auditPropertiesData.startDate &&
    format(new Date(auditPropertiesData.startDate), "MM/DD/YYYY");
  auditPropertiesDataObject.notificationDate =
    auditPropertiesData.notificationDate &&
    format(new Date(auditPropertiesData.notificationDate), "MM/DD/YYYY");
  auditPropertiesDataObject.serviceFromDate =
    auditPropertiesData.serviceFromDate &&
    format(new Date(auditPropertiesData.serviceFromDate), "MM/DD/YYYY");
  auditPropertiesDataObject.serviceToDate =
    auditPropertiesData.serviceToDate &&
    format(new Date(auditPropertiesData.serviceToDate), "MM/DD/YYYY");
  auditPropertiesDataObject.paymentReviewInd = auditPropertiesData.paymentReviewInd
    ? auditPropertiesData.paymentReviewInd
    : false;
  auditPropertiesDataObject.targetValue1 =
    auditPropertiesData.targetValue1 &&
    auditPropertiesData.targetValue1.toString();
  auditPropertiesDataObject.targetValue2 =
    auditPropertiesData.targetValue2 &&
    auditPropertiesData.targetValue2.toString();
    auditPropertiesDataObject.targetRationaleValue =
    auditPropertiesData.targetRationaleValue &&
    auditPropertiesData.targetRationaleValue.toString();
  if(eaRound){
    auditPropertiesDataObject.eaRoundTaskTriggerList = eaRound[0].eaRoundTaskList;
    for (var item of auditPropertiesDataObject.eaRoundTaskTriggerList) {
      delete item.dueInDays;
      delete item.level;
      delete item.taskCategoryName;
      delete item.taskCategoryType;
      delete item.templateDescription;
      delete item.requiredForAuditCompletionInd;
      delete item.eaProcessTemplateRoundId;
  }
  }

  return auditPropertiesDataObject;
};

export const updateRoundData = (
  currentRoundData,
  advanceRoundData,
  eaAuditRounds
) => {
  if (currentRoundData) {
    const index = currentRoundData?.index;
    const currentRound = eaAuditRounds[index];
    eaAuditRounds[index].endDate = currentRoundData?.endDate;
    eaAuditRounds[index].determinationDate =
      currentRoundData?.determinationDate;
    eaAuditRounds[index].submissionDate =
      currentRoundData?.submissionDate;
  }
  if (advanceRoundData) {
    eaAuditRounds.splice(0, 0, advanceRoundData);
  }
  return eaAuditRounds;
};
